import type { I18nDict } from '../types.ts'

export const nb: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Innstillinger',
  section_language: 'Språk',
  section_identity: 'Lokal identitet',
  section_updates: 'Appoppdatering',
  section_notifications: 'Varsler',
  section_theme: 'Visuelt tema',
  section_backup: 'Sikkerhetskopi av chat',
  section_privacy_network: 'Nettverkspersonvern',
  section_media: 'Multimedia',
  section_security: 'Sikkerhet og passord',
  section_exit: 'Lukk og slett data',
  toggle_external_links: 'Motta og vis eksterne lenker',
  hint_external_links: 'Hvis AV: ingen lenkeforhåndsvisninger i chatten og eksterne URL-er kan ikke åpnes (IP-sporingsbeskyttelse).',
  toggle_auto_media: 'Automatisk nedlasting av media og dokumenter',
  hint_auto_media: 'Hvis AV: bilder, videoer og filer lastes ikke ned i bakgrunnen — trykk manuelt i chatten.',
  toggle_require_unlock: 'Passord ved appåpning',
  hint_require_unlock: 'Når PÅ, kreves hovedpassordet hver gang du åpner ZION.',
  toggle_wipe_exit: 'Slett data ved avslutning',
  hint_wipe_exit: 'Når PÅ, tømmes midlertidig RAM-cache og sesjonsdata når appen lukkes.',
  btn_exit: 'Avslutt',
  btn_delete_all: 'SLETT ALL DATA',
  btn_lock: 'Lås appen',
  btn_back: 'Tilbake',
  warn_disable_password_title: '⚠️ ADVARSEL',
  warn_disable_password_body: 'Å deaktivere åpningspassordet betyr at hvem som helst med tilgang til enheten din kan lese de krypterte meldingene dine. Er du sikker på at du vil fortsette?',
  warn_delete_all_1: 'Vil du virkelig ødelegge hele databasen? Denne handlingen kan ikke angres.',
  warn_delete_all_2: 'Endelig bekreftelse: alle chatter, private nøkler og innstillinger slettes permanent.',
  link_blocked: 'Ekstern lenke blokkert (personverninnstillinger).',
  lang_welcome_title: 'Velkommen til ZION',
  lang_welcome_sub: 'Velg språk',
  lang_continue: 'Fortsett',
  settings_language_label: 'Appspråk',
  auth_unlock_title: 'Lås opp',
  auth_or_password: '— eller lås opp med passord —',
  auth_password_master: 'Hovedpassord',
  auth_unlock_btn: 'Lås opp',
  auth_verifying: 'Verifiserer…',
  auth_wrong_password: 'Feil passord',
  auth_unlocked: 'Låst opp ✓',
  auth_access_title: 'Bli med i ZION',
  auth_beta_spots: 'Gratis beta · plasser igjen:',
  auth_beta_full: 'Beta full ({max} brukere). Prøv igjen senere.',
  auth_beta_free: 'Gratis beta · ingen lisens kreves',
  auth_or_create: '— eller opprett en ny identitet —',
  auth_password_min: 'Passord (min. 8 tegn)',
  auth_password_confirm: 'Bekreft passord',
  auth_privacy_check: 'Jeg har lest',
  auth_privacy_link: 'Personvernerklæringen',
  auth_terms_check: 'Jeg godtar',
  auth_terms_link: 'Vilkårene for bruk',
  auth_password_local_hint: 'Passordet forlater aldri denne enheten. Ingen serverkonto.',
  auth_create_identity: 'Opprett identitet',
  auth_accept_legal_err: 'Godta personvern og vilkår for å fortsette',
  auth_generating_keys: 'Genererer nøkler og sesjon…',
  auth_generating_identity: 'Genererer anonym identitet…',
  auth_generating_detail: 'ECDH-nøkler · kallenavn · socket-sesjon · ZN- kode',
  auth_you_are: 'Du er',
  auth_daily_suffix_hint: 'Det daglige suffikset endres hver UTC-dag. For å pare, bruk ZN- koden på Hjem.',
  auth_enter: 'Gå inn i ZION',
  auth_starting: 'Starter…',
  auth_restore_title: 'Gjenopprett sikkerhetskopi',
  auth_restore_hint: 'Har du allerede en kryptert sikkerhetskopi? Gjenopprett identitet, kontakter og chatter (f.eks. etter å ha tømt cache).',
  auth_restore_file: 'Sikkerhetskopifil (.enc / .enc.json)',
  auth_restore_pass: 'Passordfrase for sikkerhetskopi',
  auth_restore_pass_ph: 'Passordfrase brukt ved eksport',
  auth_restore_btn: 'Gjenopprett sikkerhetskopi',
  auth_restore_pick_file: 'Velg en sikkerhetskopifil (.enc eller .enc.json).',
  auth_restore_need_pass: 'Skriv inn passordfrasen.',
  auth_restoring: 'Gjenoppretter…',
  auth_file_prefix: 'Fil:',
  common_accept: 'Godta',
  common_reject: 'Avvis',
  common_cancel: 'Avbryt',
  common_accepting: 'Godtar…',
  common_error: 'Feil',
  common_loading: 'Laster…',
  common_send: 'Send',
  common_copied: 'Kopiert ✓',
  common_copy_failed: 'Kopiering mislyktes',
  common_ok: 'OK',
  common_today: 'I dag',
  common_yesterday: 'I går',
  common_sending: 'Sender…',
  home_zn_midnight_hint: 'Endres ved UTC midnatt (om {h}t {m}m)',
  home_temp_empty: 'Ingen tidsbegrensede chatter. Trykk ⏱ på en kontakt for å starte en.',
  home_unread_aria: '{count} meldinger',
  home_temp_waiting: 'Venter på godkjenning…',
  home_temp_expires: 'Tidsbegrenset chat · utløper om {remaining}',
  home_temp_cancel: 'Avbryt',
  home_temp_fallback_label: 'tidsbegrenset chat',
  home_temp_invite_title: '⏱ Invitasjon til tidsbegrenset chat',
  home_temp_invite_body: '{nick} ønsker en midlertidig chat ({duration}).',
  home_temp_invite_hint: 'Godta for å begynne å utveksle meldinger som forsvinner ved utløp.',
  home_temp_accept: 'Godta',
  home_temp_reject: 'Avvis',
  home_temp_accepting: 'Godtar…',
  home_contacts_empty: 'Ingen kontakter. Del ZN- koden eller QR for å pare.',
  home_temp_chat_aria: 'Tidsbegrenset chat',
  home_btn_pair_title: 'Par',
  home_btn_settings_title: 'Innstillinger',
  home_zn_title: 'Dagens ZN- kode',
  home_btn_copy_zn: 'Kopier ZN-',
  home_btn_open_pair: 'Parings-QR',
  home_section_temp: 'Tidsbegrensede chatter',
  home_section_chat: 'Chatter',
  home_loading: 'Laster…',
  home_pair_zn_title: 'Par med ZN- kode',
  home_btn_zn_pair: 'Send forespørsel',
  home_copied: 'Kopiert ✓',
  home_copy_failed: 'Kopiering mislyktes',
  home_pair_request_title: 'Kontaktforespørsel',
  home_pair_request_body: '{name} vil chatte.',
  home_pair_reject: 'Avvis',
  home_pair_accept: 'Godta',
  home_pair_accepting: 'Godtar…',
  home_pair_accept_failed: 'Godkjenning mislyktes',
  home_zn_digits_err: 'Skriv inn de 5 sifrene etter ZN-.',
  home_sending: 'Sender…',
  chat_rename: 'Gi nytt navn',
  chat_rename_matrix: '[GI NYTT NAVN]',
  chat_rename_title: 'Gi kontakt nytt navn',
  chat_menu_title: 'Chat-alternativer',
  chat_loading: 'Laster meldinger…',
  chat_reply_to: 'Svar til',
  chat_cancel_title: 'Avbryt',
  chat_voice_lock_hint: 'Sveip opp for å låse opptak',
  chat_voice_locked: 'Opptak låst — trykk Ferdig',
  chat_voice_stop: 'FERDIG',
  chat_voice_stop_title: 'Ferdig',
  chat_voice_preview_label: 'Stemme-forhåndsvisning — lytt før du sender',
  chat_voice_send: 'SEND',
  chat_voice_send_title: 'Send',
  chat_timer_label: 'Timer',
  chat_timer_title: 'Meldingstimer',
  chat_timer_off: 'AV',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Bilde',
  chat_photo_title: 'Bilde',
  chat_voice_hold: 'Hold for å ta opp',
  chat_voice_hold_title: 'Hold for å ta opp',
  chat_doc: 'Dok',
  chat_doc_title: 'Dokument',
  chat_attach_title: 'Vedlegg',
  chat_input_placeholder: 'E2E-kryptert melding…',
  chat_send: 'Send',
  chat_rename_modal_title: 'Gi kontakt nytt navn',
  chat_rename_nickname: 'Kallenavn: @{nick}',
  chat_rename_placeholder: 'Egendefinert navn',
  chat_rename_cancel: 'Avbryt',
  chat_rename_save: 'Lagre',
  chat_action_reply: '↩ Svar',
  chat_action_copy: '⎘ Kopier',
  chat_action_delete_me: '🗑 Slett for meg',
  chat_action_delete_all: '🗑 Slett for alle',
  chat_action_cancel: 'Avbryt',
  chat_menu_clear_me: '🗑 Tøm chat (kun for meg)',
  chat_menu_clear_all: '🗑 Slett chat for alle',
  chat_menu_cancel: 'Avbryt',
  chat_doc_send_title: 'Send dokument',
  chat_doc_default_name: 'dokument',
  chat_doc_send_hint: 'Filen komprimeres, E2E-krypteres og sendes. Maks 5 MB.',
  chat_doc_cancel: 'Avbryt',
  chat_doc_send_encrypted: 'Send kryptert',
  chat_doc_too_large: '⚠️ FILEN ER FOR STOR: Maksimal sikkerhetsgrense for dokumenter er 5 MB.',
  chat_doc_unsupported: 'Dokumenttypen støttes ikke.',
  chat_copy_failed: 'Kopiering mislyktes',
  chat_confirm_delete_me: 'Slette denne meldingen bare for deg?',
  chat_confirm_delete_all: 'Slette denne meldingen for alle?',
  chat_confirm_clear_all: 'Slette hele chatten for alle? Denne handlingen kan ikke angres.',
  chat_confirm_clear_me: 'Tømme chatten bare for deg?',
  chat_jump_new: '↓ Nye meldinger',
  chat_empty: 'Ingen meldinger. Skriv noe for å starte.',
  chat_voice_err_short: 'Talemelding for kort (minimum 1 sekund).',
  chat_voice_err_long: 'Talemelding for lang (maksimum 2 minutter).',
  chat_voice_err_large: 'Talemelding for stor (maks 3 MB).',
  chat_voice_err_start: 'Taleopptak kunne ikke startes.',
  chat_destroyed: '✉ Melding lest og ødelagt',
  chat_destroyed_title: 'Melding lest og ødelagt',
  chat_hold_options: 'Hold for alternativer',
  chat_reply_fallback: 'Melding',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',
  pair_zn_midnight_hint: 'ZN- koden endres ved UTC midnatt (om {h}t {m}m).',
  pair_copied: 'Kopiert ✓',
  pair_copy_failed: 'Kopiering mislyktes',
  pair_title: 'Parings',
  pair_zn_title: 'Din ZN- kode i dag',
  pair_btn_copy_zn: 'Kopier ZN- kode',
  pair_tab_mine: 'Min QR',
  pair_tab_scan: 'Skann / ZN-',
  pair_qr_aria: 'Parings-QR',
  pair_expires_in: 'Utløper om',
  pair_btn_copy_payload: 'Kopier payload',
  pair_btn_regen_qr: 'Generer ny QR',
  pair_qr_hint: 'Vis denne QR-en til den andre enheten. Gyldig i 10 minutter — kompatibel med Android-appen.',
  pair_expired: 'utløpt',
  pair_contact_zn_title: 'Kontaktens ZN- kode',
  pair_zn_prefix_hint: 'Prefikset <strong>ZN-</strong> er allerede satt — skriv inn bare de 5 bokstavene/sifrene.',
  pair_btn_zn_request: 'Send ZN- forespørsel',
  pair_paste_title: 'Eller lim inn en ZION1:: QR',
  pair_paste_hint: 'Lim inn en <code>ZION1::</code> payload eller last opp et bilde av QR-koden.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Fra bilde / kamera',
  pair_btn_connect_qr: 'Koble til med QR',
  pair_zn_digits_err: 'Skriv inn de 5 sifrene etter ZN-.',
  pair_sending: 'Sender forespørsel…',
  pair_reading_qr: 'Leser QR…',
  pair_qr_not_found: 'QR-kode ikke funnet i bildet.',
  pair_zn_read_ok: 'ZN- kode lest — bekreft med Send forespørsel.',
  pair_qr_read_ok: 'QR lest — bekreft med Koble til med QR.',
  pair_qr_read_err: 'Feil ved lesing av QR.',
  settings_identity_hint: 'Passord og nøkler blir i denne nettleseren. Ingen serverkonto.',
  settings_btn_add_home: 'Veiledning for Legg til på Hjemskjerm',
  settings_devices_title: 'Tilknyttede enheter',
  settings_devices_hint: 'Multi-enhet Zero-Knowledge: nøkler sendes E2E-kryptert. Serveren er bare en relé.',
  settings_btn_link_device: 'Koble til ny enhet',
  settings_btn_sync_pc: 'Synk PC-historikk',
  settings_no_devices: 'Ingen tilknyttede enheter.',
  settings_device_self: 'denne enheten',
  settings_version_prefix: 'Versjon:',
  settings_ios_push_hint: '<strong>iPhone:</strong> varsler = PWA fra Hjem + Banner/Lyd PÅ. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Tving appoppdatering',
  settings_updating: 'Oppdaterer…',
  settings_push_mode_prefix: 'Modus:',
  settings_push_hint_ios: '<strong>iPad/iPhone:</strong> varsler fungerer bare når ZION åpnes fra ikonet på hjemskjermen (Del → Legg til på hjemskjermen). I vanlig Safari er de <em>ikke</em> tilgjengelige — selv på iOS 17. Etter installasjon på hjemskjermen, kom tilbake hit og trykk Aktiver varsler.',
  settings_btn_enable_push: 'Aktiver push-varsler',
  settings_btn_desktop_notify: 'Skrivebordsvarsler (PC)',
  settings_btn_disable_push: 'Deaktiver varsler',
  settings_desktop_requesting: 'Ber om skrivebordstillatelse…',
  settings_desktop_ok: 'Skrivebordsvarsler aktive (lyd + popup ved ny melding).',
  settings_desktop_denied: 'Tillatelse nektet eller støttes ikke.',
  settings_push_no_session: 'Sesjonen er ikke klar.',
  settings_push_requesting: 'Ber om tillatelse…',
  settings_push_active: 'Varsler aktive.',
  settings_push_disabled: 'Varsler deaktivert.',
  settings_theme_hint: 'Samme temaer som ZION Android-appen.',
  settings_theme_recommended: 'Anbefalt',
  settings_backup_hint: 'JSON-fil kryptert med passordfrase (kompatibel med Android v2-format). Lagre på PC-en: kontakter, chatter og webidentitet.',
  settings_backup_pass_label: 'Passordfrase for sikkerhetskopi',
  settings_backup_pass_ph: 'Dedikert passordfrase (min. 8 tegn)',
  settings_btn_export_backup: 'Eksporter sikkerhetskopi',
  settings_backup_file_label: 'Gjenopprett fra fil',
  settings_backup_import_pass_label: 'Passordfrase for sikkerhetskopi',
  settings_backup_import_pass_ph: 'Passordfrase brukt ved eksport',
  settings_btn_import_backup: 'Gjenopprett sikkerhetskopi',
  settings_backup_file_prefix: 'Fil: {name}',
  settings_backup_pass_min: 'Passordfrasen må være minst 8 tegn.',
  settings_backup_creating: 'Oppretter sikkerhetskopi…',
  settings_backup_pick_file: 'Velg en sikkerhetskopifil (.enc eller .enc.json).',
  settings_backup_need_pass: 'Skriv inn passordfrasen for sikkerhetskopien.',
  settings_backup_restoring: 'Gjenoppretter…',
  settings_backup_overwrite_confirm: 'Overskrive lokal data?',
  settings_modal_ok: 'OK',
  temp_duration_5m: '5 minutter',
  temp_duration_10m: '10 minutter',
  temp_duration_15m: '15 minutter',
  temp_duration_30m: '30 minutter',
  temp_duration_1h: '1 time',
  temp_duration_6h: '6 timer',
  temp_duration_24h: '24 timer',
  temp_duration_7d: '7 dager',
  temp_remaining_expired: 'Utløpt',
  temp_remaining_days: '{days}d {hours}t',
  temp_remaining_hours: '{hours}t {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Tidsbegrenset chat · midlertidige meldinger',
  temp_empty: 'Ingen midlertidige meldinger.',
  temp_empty_hint: 'Skriv en midlertidig melding. Den forsvinner når timeren utløper.',
  temp_input_placeholder: 'Midlertidig melding…',
  temp_send: 'Send',
  temp_waiting_accept: 'Venter på at {name} godtar den tidsbegrensede chatten…',
  temp_waiting_placeholder: 'Venter på godkjenning…',
  temp_expires_in: 'Utløper om {remaining}',
  temp_duration_title: 'Tidsbegrenset chat',
  temp_duration_with: 'Med {name}',
  temp_duration_hint: 'Velg varighet — chatten forsvinner fra begge enheter.',
  temp_sending_invite: 'Sender invitasjon…',
  voice_lock_hint: 'Sveip opp for å låse opptak',
  voice_locked: 'Opptak låst — trykk Ferdig',
  add_home_title: 'Legg til på hjemskjermen (iPhone / iPad)',
  add_home_guide_title: 'Safari-veiledning',
  add_home_step1: 'Åpne <strong>Safari</strong> på denne siden (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Trykk på <strong>Del</strong> (firkant med pil oppover)',
  add_home_step3: 'Velg <strong>Legg til på hjemskjermen</strong>',
  add_home_step4: 'Åpne ZION fra <strong>ikonet</strong> — ikke fra en Safari-fane',
  add_home_hint: 'På iOS/iPadOS 16.4+ støtter hjemskjermappen Web Push-varsler og chat-tastaturet. Etter installasjon, gå til <strong>Innstillinger → Aktiver varsler</strong>.',
  add_home_btn_continue: 'Forstått — fortsett',
  add_home_btn_skip: 'Hopp over for nå',
  search_title: 'Søk med ZN- kode',
  search_label: 'Daglig ZN- kode',
  search_placeholder: 'ZN-123456',
  search_btn: 'Søk',
  search_hint: 'Skriv inn kontaktens ZN- kode. Ingen kallenavnsøk — identiteten er kun lokal.',
  search_format_err: 'Format: ZN-123456',
  search_resolving: 'Løser kode…',
  search_invalid_code: 'Ugyldig kode — be om en oppdatert ZN- (åpne ZION på nytt på den andre personens enhet)',
  search_session_found: 'sesjon funnet',
  search_tap_to_send: 'Trykk for å sende forespørsel',
  search_socket_not_ready: 'Socket-sesjonen er ikke klar',
  search_request_sent: 'Forespørsel sendt ✓',
  search_request_failed: 'Sending mislyktes',
  license_title: 'Web- / iPhone-lisensaktivering',
  license_heading: 'Lisens',
  license_heading_updated: 'Oppdaterte vilkår',
  license_hint: 'Skriv inn koden <strong>ZION-XXXX-XXXX-XXXX</strong> kjøpt på zionyx.ch. Den kobles til denne nettleseren (lokal nøkkel).',
  license_code_label: 'Lisenskode',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Aktiver lisens',
  license_beta_hint: 'Web-beta: bruk en dedikert iPhone-lisens hvis tilgjengelig.',
  license_accept_legal_err: 'Godta personvern og vilkår for å fortsette',
  license_need_code: 'Skriv inn lisenskoden',
  license_verifying: 'Verifiserer lisens…',
  license_invalid_or_used: 'Ugyldig lisens eller allerede brukt på en annen enhet',
  license_active: 'Lisens aktiv ✓',
  license_err_not_found: 'Ugyldig lisenskode',
  license_err_conflict: 'Lisens allerede koblet til en annen enhet',
  license_err_rate_limit: 'For mange forsøk — vent et minutt',
  license_err_generic: 'Lisensfeil',
  link_device_title: 'Koble til ny enhet',
  link_device_hint: 'På <strong>PC-en</strong> din, åpne Innstillinger → Koble til ny enhet: du ser den <strong>grønne QR-en</strong>. Skann den nedenfor (kamera eller bilde).',
  link_device_status_ready: '[KLAR]',
  link_device_upload_label: 'Last opp QR-bilde',
  link_device_btn_camera: 'Åpne kamera / galleri',
  link_device_placeholder: 'QR-lenke eller payload…',
  link_device_btn_send_vault: 'Send kryptert hvelv',
  link_device_err_invalid_qr: 'Ugyldig eller utløpt QR.',
  link_device_status_invalid: '[UGYLDIG QR]',
  link_device_status_sync_complete: '[SYNK FULLFØRT]',
  link_device_status_transfer_failed: '[OVERFØRING MISLYKTES]',
  link_device_status_qr_detected: '[QR OPPDAGET — OVERFØRER...]',
  link_device_status_tap_camera: '[TRYKK PÅ DEN GRØNNE KNAPPEN — IPHONE-KAMERA]',
  link_device_status_use_camera_below: '[BRUK KAMERA / GALLERI NEDENFOR]',
  link_device_status_point_camera: '[RETT KAMERA MOT PC-QR...]',
  link_device_status_decoding: '[DEKODER QR...]',
  link_device_status_qr_not_found: '[QR IKKE FUNNET]',
  link_device_status_decode_failed: '[DEKODING MISLYKTES]',
  link_device_status_opened_from_qr: '[ÅPNET FRA QR — STARTER...]',
  link_recv_title: 'Koble fra telefon',
  link_recv_hint_compact:
    'Skann denne <strong>grønne QR</strong> med telefonen (Innstillinger → Koble ny enhet). Hvelvet er ende-til-ende-kryptert.',
  link_recv_hint_auth:
    'Har du allerede ZION på telefonen? Skann denne QR med <strong>Kamera</strong> — PC-en kobles og logger inn automatisk.',
  link_recv_qr_alt: 'QR for enhetskobling',
  link_recv_copy_link: 'Kopier lenke',
  link_recv_awaiting: '[VENTER PÅ TELEFONSKANNING — TUNNEL ÅPEN...]',
  link_recv_failed: '[PARING MISLYKTES]',
  link_recv_tunnel_lost:
    'Tunnelen ble avbrutt — hvelvet kan fortsatt være underveis. Prøv å skanne QR på nytt.',
  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Ny kryptert melding',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Midlertidig melding',
  force_update_title: '🚨 OBLIGATORISK KRITISK OPPDATERING — For å fortsette å bruke Zionyx sikkert må du laste ned den nyeste versjonen.',
  force_update_desc: 'Den installerte klienten er ikke kompatibel med minimumsversjonen som er aktiv på serveren.',
  force_update_versions: 'Installert: v{current} · Påkrevd: v{required}',
  force_update_btn: 'OPPDATER NÅ',
}
